export enum SortOrder {
    ASCENDING = 'asc',
    DESCENDING = 'desc',
}

export enum FormMode {
    EDIT = 'edit',
    CREATE = 'create',
}
